<template>
  <div>
    <b-form-group
      label="Açıklama"
      label-for="content"
    >
      <validation-provider
        #default="{ errors }"
        name="Açıklama"
        rules="required"
      >
        <b-form-input
          id="content"
          v-model="dataItem.content"
          placeholder="Açıklama"
        />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
  </div>
</template>
<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'

export default {
  name: 'CurrentAccountLineContent',
  components: { ValidationProvider, BFormGroup, BFormInput },
  computed: {
    dataItem() {
      return this.$store.getters['currentAccountLines/dataItem']
    },
  },
}
</script>
